import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueMarkdown from 'vue-markdown'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fas);
dom.watch();
library.add(faCoffee);
Vue.component('fai', FontAwesomeIcon);
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
    components: {
        VueMarkdown
    }
}).$mount('#app');
